export default __webpack_public_path__ + "static/media/OnionRings.443c92b7.jpg";